<template>
    <a v-bind:href="(item.LinkDirectly == true ? item.TrialUrl : item.Url)"
	   v-bind:target="(item.Url.indexOf('/') == 0 ? '_self' : '_blank')" 
	   class="card card-event card-event--item">

		<div class="card-content">
			<div class="card-content-title">
				<div class="card-content-title-wrap">
					<h3 v-if="item.Title">{{ item.Title }}</h3>
					<!--<p class="card-event-range">
						<span v-if="item.StartDate">
							{{ formatDate(item.StartDate) }}
						</span>
						<span v-if="item.EndDate === '0001-01-01T00:00:00'" class="d-none">&nbsp;</span>
						<span v-else>
							- {{ formatDate(item.EndDate) }}
						</span>
					</p>-->
					<div v-if="item.Description">
						{{ item.Description }}
					</div>
				</div>
			</div>
			<div class="cta-link">View Details</div>
		</div>
	</a>
</template>

<script>
	import DateFormatService from '../../services/date-format.service';

	export default {
		props: ['item', 'displayDate', 'displaySummary'],
		components: {

		},
		mounted: function () {

		},
		methods: {
			formatDate(date) {
				return DateFormatService.formatDate(date);
			},
        },
    }
</script>